import React, {
  useCallback,
  useMemo,
  useEffect,
  useRef,
  useState,
} from 'react';
import { toast } from 'react-toastify';

import { ButtonBase, Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Delete as DeleteIcon } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';

import api from '~/services/api';

import DeleteButtonWithModal from '../DeleteButtonWithModal';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function QRFotoDialog({
  open,
  handleClose,
  title,
  children,
  actions,
  iddescarganf,
  idposto,
  nfdescarganf,
  isUpdate,
}) {
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);

  const handleGetDados = useCallback(async () => {
    try {
      const response = await api.get(
        `descargasnfs/fotos/${iddescarganf}/${idposto}`
      );
      // console.log(JSON.stringify(response.data));
      setData(response.data);
    } catch (err) {
      setData([]);
      err.map((e) => toast.error(e));
    } finally {
    }
  }, [iddescarganf, idposto]);

  useEffect(() => {
    // console.log('1');
    if (iddescarganf && open) {
      handleGetDados();
    }
  }, [iddescarganf, idposto, open]);

  // const handleDelete = () => {
  //   alert("Item excluído!");
  //   handleClose();
  // };

  const handleDelete = useCallback(async () => {
    try {
      setLoading(true);
      await api.delete(`descargasnfs/fotos/${iddescarganf}/${idposto}`);
      handleClose();
    } catch (err) {
      err.map((e) => toast.error(e));
    } finally {
      setLoading(false);
    }
  }, [iddescarganf, idposto]);

  return (
    <Dialog
      fullWidth
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      {title && (
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {title}
        </DialogTitle>
      )}
      <DialogContent dividers>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2} // Espaço entre os botões
          p={2} // Padding interno do container
        >
          <ButtonBase
            onClick={() =>
              window.open(
                data?.urlfotofrentefotodescarganf,
                '_blank',
                'noopener,noreferrer'
              )
            }
            style={{
              borderRadius: 8,
              padding: '8px 16px',
              backgroundColor: '#f0f0f0',
              transition: 'transform 0.1s, box-shadow 0.1s',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              width: '200px',
              marginBottom: '16px', // Espaço entre os botões
            }}
            onMouseDown={(e) =>
              (e.currentTarget.style.transform = 'scale(0.95)')
            }
            onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          >
            <Typography variant="body2" color="primary">
              Foto Frente
            </Typography>
          </ButtonBase>

          <ButtonBase
            onClick={() =>
              window.open(
                data?.urlfotoversofotodescarganf,
                '_blank',
                'noopener,noreferrer'
              )
            }
            style={{
              borderRadius: 8,
              padding: '8px 16px',
              backgroundColor: '#f0f0f0',
              transition: 'transform 0.1s, box-shadow 0.1s',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              width: '200px',
              marginBottom: '16px', // Espaço entre os botões
            }}
            onMouseDown={(e) =>
              (e.currentTarget.style.transform = 'scale(0.95)')
            }
            onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          >
            <Typography variant="body2" color="primary">
              Foto Verso
            </Typography>
          </ButtonBase>

          {isUpdate && (
            <DeleteButtonWithModal onDelete={handleDelete} disabled={loading} />
          )}
        </Box>
        {children}
      </DialogContent>
      <DialogActions>{actions}</DialogActions>
    </Dialog>
  );
}

{
  /* <ButtonBase
              onClick={() => handleDelete() }
              style={{
                borderRadius: 8,
                padding: "8px 16px",
                backgroundColor: "#ffdddd",
                transition: "transform 0.1s, box-shadow 0.1s",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                width: "200px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.95)")}
              onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              aria-label="Excluir"
            >
              <DeleteIcon style={{ color: "#d32f2f" }} />
              <Typography variant="body2" style={{ color: "#d32f2f" }}>
                Excluir
              </Typography>
            </ButtonBase> */
}
